/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPackage } from './SubscriptionPackage';
import {
    SubscriptionPackageFromJSON,
    SubscriptionPackageFromJSONTyped,
    SubscriptionPackageToJSON,
    SubscriptionPackageToJSONTyped,
} from './SubscriptionPackage';

/**
 * 
 * @export
 * @interface SubscriptionData
 */
export interface SubscriptionData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionData
     */
    billingCycle?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionData
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionData
     */
    endDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionData
     */
    isFreeTrial?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionData
     */
    status?: string;
    /**
     * 
     * @type {SubscriptionPackage}
     * @memberof SubscriptionData
     */
    currentPackage?: SubscriptionPackage | null;
    /**
     * 
     * @type {SubscriptionPackage}
     * @memberof SubscriptionData
     */
    nextPackage?: SubscriptionPackage | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionData
     */
    nextBillingCycle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionData
     */
    extraPaidDomainsCount?: number | null;
}

/**
 * Check if a given object implements the SubscriptionData interface.
 */
export function instanceOfSubscriptionData(value: object): value is SubscriptionData {
    return true;
}

export function SubscriptionDataFromJSON(json: any): SubscriptionData {
    return SubscriptionDataFromJSONTyped(json, false);
}

export function SubscriptionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionData {
    if (json == null) {
        return json;
    }
    return {
        
        'billingCycle': json['billingCycle'] == null ? undefined : json['billingCycle'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'isFreeTrial': json['isFreeTrial'] == null ? undefined : json['isFreeTrial'],
        'status': json['status'] == null ? undefined : json['status'],
        'currentPackage': json['currentPackage'] == null ? undefined : SubscriptionPackageFromJSON(json['currentPackage']),
        'nextPackage': json['nextPackage'] == null ? undefined : SubscriptionPackageFromJSON(json['nextPackage']),
        'nextBillingCycle': json['nextBillingCycle'] == null ? undefined : json['nextBillingCycle'],
        'extraPaidDomainsCount': json['extraPaidDomainsCount'] == null ? undefined : json['extraPaidDomainsCount'],
    };
}

export function SubscriptionDataToJSON(json: any): SubscriptionData {
    return SubscriptionDataToJSONTyped(json, false);
}

export function SubscriptionDataToJSONTyped(value?: SubscriptionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingCycle': value['billingCycle'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'isFreeTrial': value['isFreeTrial'],
        'status': value['status'],
        'currentPackage': SubscriptionPackageToJSON(value['currentPackage']),
        'nextPackage': SubscriptionPackageToJSON(value['nextPackage']),
        'nextBillingCycle': value['nextBillingCycle'],
        'extraPaidDomainsCount': value['extraPaidDomainsCount'],
    };
}

